module.exports = __webpack_public_path__ + "img/visa.792e9f7c.svg";